// @flow

export const SET: 'CAR.SET' = 'CAR.SET';
export const UNSET: 'CAR.UNSET' = 'CAR.UNSET';
export const BATCH_SET: 'CAR.BATCH_SET' = 'CAR.BATCH_SET';
export const END_SESSION: 'CAR.END_SESSION' = 'CAR.END_SESSION';